import {
  updateUser,
  show,
  scheduleEvent,
  checkRoom,
  updateProfileImage
} from '@/api/user'
import Cookies from 'js-cookie'
import {
  getToken,
  setToken
} from '@/utils/auth'

const companies = {
  state: {
    currentUser: (Cookies.get('currentUser')) ? JSON.parse(Cookies.get('currentUser')) : {},
    token: getToken(),
    roles: (Cookies.get('roles')) ? Cookies.get('roles') : {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      Cookies.set('roles', roles)
    },
    SET_USER: (state, user) => {
      state.currentUser = user
      Cookies.set('currentUser', user)
    },
  },
  actions: {
    /**
     * Get all Update Profile for superadmin 
     * @param {*} param0 
     * @author Madhura Shah
     */
    UpdateProfile({
      commit
    }, users) {

      return new Promise((resolve, reject) => {
        updateUser(users).then(response => {

          if (response.data.data) {
            commit('SET_USER', response.data.data)

          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * Show Profile for superadmin
     *  @param {*} users
     */
    showProfile({
      commit
    }, users) {

      return new Promise((resolve, reject) => {
        show(users).then(response => {

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     *  Schedule Event
     * @param {*} param0 
     * @author Madhura Shah
     */
    ScheduleEvent({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        scheduleEvent(data).then(response => {
          if (response.data.token != null) {
            commit('SET_TOKEN', response.data.token)
            setToken(response.data.token)
            if (response.data.data) {
              commit('SET_USER', response.data.data)
              commit('SET_ROLES', response.data.data.user_role)
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Check room available or not
     * @param {*} param0 
     * @param {*} data 
     */
    CheckRoom({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        checkRoom(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * on upload image for profile added on 29/09/2021
     * @param {*} param0 
     * @param {*} data 
     */
    updateProfileImage({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        updateProfileImage(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },


  },
}

export default companies
